import { mount, createLocalVue } from "@vue/test-utils";
import HTMLSanitize from "../../plugins/html-sanitize";

const localVue = createLocalVue();
localVue.use(HTMLSanitize);

describe("plugin HTMLSanitize", () => {
  it("sanitiza el html no seguro", () => {
    const MyComponent = localVue.extend({
      template: `<div><p v-safe-html="myHtmlstring"></p></div>`,
      data() {
        return {
          myHtmlstring:
            '<span>html seguro</span><script>alert("html no seguro");</script>'
        };
      }
    });

    const wrapper = mount(MyComponent, {
      localVue
    });

    expect(wrapper.find("p").html()).toEqual("<p><span>html seguro</span></p>");
  });
});
